module.exports = __webpack_public_path__ + "img/大图--灰调.8fdc10c9.png";